import { BlurbCard } from 'ui/components/2-molecules/Card/BlurbCard';
import { Container } from 'ui/components/4-habitats/Container';

export const BlurbCardFeature: React.FC<Content.BlurbCard> = ({ content, settings }) => (
	<Container section width="std">
		<BlurbCard {...content?.properties} settings={settings.properties} />
	</Container>
);
